import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, withMultipleStyles} from "../../../styles/Styles";
import {GridList, Typography} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import View from "../commons/View";
import {Pagination} from "@material-ui/lab";
import {
  fetchActivityDummyPlayerStats,
  fetchActivityPlayerStats,
  fetchOpenActivityPlayerStats
} from "../../actions/funActions";
import AppTextWrapper from "../commons/AppTextWrapper";
import {FontWeightMedium} from "../../../res/FontWeight";
import AppImage from "../commons/AppImage";
import {SpaceNormal, SpaceXSmall} from "../../../res/Spacing";
import {ColorSubTitle, ColorTheme, ColorTitle} from "../../../styles/Colors";
import Space from "../commons/Space";
import AppText from "../commons/AppText";
import TextView from "../commons/TextView";

const useStyles = () => ({
  gridItemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    paddingLeft: 8,
    paddingRight: 8,
  },
  messageBox: {
    display: 'flex',
    width: '100%',
    minHeight: 300,
    alignItems: 'center',
    justifyContent: 'center'
  },
  winnerName: {
    textAlign: 'left',
    fontWeight: FontWeightMedium,
  },
  winnerState: {
    marginLeft: SpaceNormal,
    textAlign: 'right',
    fontWeight: FontWeightMedium,
  }
});

class ActivityPlayerStats extends React.Component {

  constructor(props) {
    super(props);

    this.readOnly = props.readOnly;
    this.state = {
      items: null,
    };

  }

  componentDidMount() {
    this.fetchActivityPlayerStats();
  }

  componentWillUnmount() {
  }

  render() {
    const {uiConfigs, classes, items} = this.props;
    const isLoading = items.isLoading;

    if (isLoading) {
      return (
        <View className={classes.flexColumn} style={{justifyContent: 'center'}}>
          <CircularProgress style={{color: uiConfigs.loadingColor || ColorTheme}} />
        </View>
      );
    }

    const showMessage = (!isLoading || (items.errMsg && items.errMsg.length > 0) || (items.errMsgF && items.errMsgF.length > 0)) && items.paginated.data.length === 0 && items.paginated.totalSize === 0;
    let message = null;
    if (items.paginated.data.length === 0) {
      if (items.errMsg && items.errMsg.length > 0) {
        message = items.errMsg;
      } else if (items.errMsgF && items.errMsgF.length > 0) {
        message = <FormattedMessage id={items.errMsgF}/>;
      } else if (!isLoading) {
        if (items.paginated.totalSize > 0) {
          message = <FormattedMessage id={'activity.noMorePlayerStats'}/>;
        } else {
          message = <FormattedMessage id={this.props.inPreview ? 'activity.dummyPlayerListMessage' : 'noPlayersPlayed'}/>;
        }
      }
    }

    return (
      <div className={classes.flexColumn}>
        {!message ?
          <GridList cols={1} className={classes.viewColumnFullWidthNoCenter} cellHeight={'auto'}>
            {items.paginated.data.map((item, index) => {
              return this.getViewForItem(index, item);
            })}
          </GridList>
          :
          <div className={classes.messageBox}>
            <TextView fontSizeN={this.props.uiConfigs.fontSize} variant={'subtitle1'} color={this.props.uiConfigs.overlayTitleColor} className={classes.typoMedium}>
              {message}
            </TextView>
          </div>
        }

        {!isLoading && (items.paginated.page > 1 || items.paginated.canLoadMore) ?
          <Pagination
            color="primary"
            style={{marginTop: 12}}
            size={"small"}
            count={Math.max(items.paginated.page, Math.ceil(items.paginated.totalSize/items.paginated.perPage))}
            page={items.paginated.page}
            showFirstButton={true}
            defaultPage={6}
            siblingCount={0}
            onChange={(event, page) => {
              this.handleTableChange(event, {page: page});
            }}
          />
          : null
        }
      </div>
    );
  }

  getViewForItem(index, item) {
    const {classes, uiConfigs} = this.props;

    const titleColor = uiConfigs ? uiConfigs.overlayTitleColor : ColorTitle;
    const subTitleColor = uiConfigs ? uiConfigs.overlaySubTitleColor : ColorSubTitle;

    const name = item.user.name || item.user.username;
    const imageUrl = item.user.imageUrl;

    const userIconSize = 36 * uiConfigs.sizeFactor;
    let marginTop = 0;
    if (index === 0) {
      marginTop = 8;
    }
    return (
      <View style={{width: '100%', marginTop: marginTop, marginBottom: 12, padding: 2}}>
        {/*<Touchable onPress={this.onUserClicked}>*/}
        <View className={classes.viewRow}>
          <View style={{
            width: userIconSize,
            marginEnd: SpaceXSmall}}>
            <AppImage
              style={{width: userIconSize, height: userIconSize, borderRadius: userIconSize / 2}}
              source={imageUrl}
            />
          </View>
          <Space verticalSpace={1} />
          <View className={classes.viewColumnFullWidthNoCenter}>
            <AppTextWrapper
              fontSizeN={uiConfigs.fontSize}
              textAlign={'left'}
              variant={'body1'}
              numberOfLines={2}
              className={classes.winnerName}
              style={{
                color: titleColor
              }}>{name}
            </AppTextWrapper>
          </View>
          {item.value ?
            <AppText
              variant={'body1'}
              fontSizeN={uiConfigs.fontSize}
              className={classes.winnerState}
              style={{
                color: subTitleColor}}>
              {item.value}
            </AppText>
            : null
          }
        </View>
        {/*</Touchable>*/}
      </View>
    );
  }

  handleTableChange = (type, { page }) => {
    this.fetchActivityPlayerStats(page);
  }

  fetchActivityPlayerStats(page = 1) {
    const {activityId} = this.props;
    if (this.readOnly) {
      this.props.fetchOpenActivityPlayerStats(activityId, page);
    } else if (activityId > 0) {
      this.props.fetchActivityPlayerStats(activityId, page);
    } else {
      setTimeout(() => {
        this.props.fetchActivityDummyPlayerStats(activityId, page);
      }, 200);
    }
  }

}

ActivityPlayerStats.propTypes = {
  classes: PropTypes.object,
  items: PropTypes.object,
  activityId: PropTypes.number,

  fetchActivityPlayerStats: PropTypes.func,
  fetchActivityDummyPlayerStats: PropTypes.func,
};

ActivityPlayerStats.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    items: state.admin.activityWinners,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivityPlayerStats: (id, page) => dispatch(fetchActivityPlayerStats(id, page)),
    fetchActivityDummyPlayerStats: (id, page) => dispatch(fetchActivityDummyPlayerStats(id, page)),
    fetchOpenActivityPlayerStats: (id, page) => dispatch(fetchOpenActivityPlayerStats(id, page)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(ActivityPlayerStats));
